﻿import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

import { Row, Col } from "react-bootstrap";
import classes from "./login.module.scss";
import { ReactComponent as LogoSvg } from "@/assets/images/mobile/logo-agro.svg";

import Fetching from "@/components/Fetching/Fetching";

import { changePassword } from "@/redux/actions/auth.actions";
import { FINAL_LOGIN_REQUEST } from "@/redux/types/auth.types";

const ChangePassword = () => {
	const navigate = useNavigate();
	const { token } = useParams();
	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const { isFetching } = useSelector((state) => state.auth);

	const [password, setPassword] = useState("");
	const [confirmPassowrd, setConfirmPassowrd] = useState("");

	const handleClickImage = () => {
		dispatch({ type: FINAL_LOGIN_REQUEST });
		navigate("/");
	};

	const handleInputPassword = (e) => {
		const isValid = e.target.validity.valid;
		if (isValid) {
			setPassword(e.currentTarget.value);
		}
	};

	const handleKeyPress = (e) => {
		const keyCode = e.which || e.keyCode;
		if (keyCode === 13) {
			handleChangePassword();
		}
	};

	const handleChangePassword = () => {
		let validate = true;

		if (!password) {
			validate = false;
			addToast("Debe ingresar una contraseña para continuar", {
				appearance: "error",
			});
		}

		if (password.length < 4 && validate) {
			validate = false;
			addToast("La contraseña debe contener al menos 4 caracteres", {
				appearance: "error",
			});
		}

		if (!confirmPassowrd && validate) {
			validate = false;
			addToast("Debe confirmar su contraseña para continuar", {
				appearance: "error",
			});
		}

		if (password !== confirmPassowrd && validate) {
			validate = false;
			addToast("Las contraseñas ingresadas no coinciden", {
				appearance: "error",
			});
		}

		if (validate) {
			dispatch(changePassword(password, token)).then(() => {
				navigate("/");
			});
		}
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<div className={classes.loginGlobal}>
			<Row className={classes.main}>
				<Col sm={12} className={classes.header}>
					<LogoSvg className="logo" onClick={() => handleClickImage()} />
				</Col>

				<Col sm={12} className={classes.form}>
					<Row>
						<Col sm={12} className={classes.title}>
							RESTABLECER CONTRASEÑA
						</Col>

						<Col className={classes.inputContent} sm={12}>
							<input
								type="password"
								className={classes.input}
								placeholder="Nueva Contraseña"
								value={password}
								pattern="[0-9]{0,13}"
								onChange={(e) => handleInputPassword(e)}
								onKeyPress={(e) => handleKeyPress(e)}
							/>
						</Col>

						<Col className={classes.inputContent} sm={12}>
							<input
								type="password"
								className={classes.input}
								placeholder="Confirmar Contraseña"
								value={confirmPassowrd}
								onChange={(e) => setConfirmPassowrd(e.currentTarget.value)}
								onKeyPress={(e) => handleKeyPress(e)}
							/>
						</Col>
					</Row>
				</Col>

				<Col sm={12} className={classes.submit} onClick={() => handleChangePassword()}>
					Actualizar Contraseña
				</Col>
			</Row>
		</div>
	);
};

export default ChangePassword;
